import { render, staticRenderFns } from "./MultiselectObjects.vue?vue&type=template&id=49c80f34&"
import script from "./MultiselectObjects.vue?vue&type=script&lang=js&"
export * from "./MultiselectObjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports